import { useEffect } from "react";

let activeLockCount = 0;
let previousBodyOverflow = "";
let previousHtmlOverflow = "";

export const useScrollLock = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return;

    const body = document.body;
    const html = document.documentElement;
    activeLockCount += 1;

    if (activeLockCount === 1) {
      previousBodyOverflow = body.style.overflow;
      previousHtmlOverflow = html.style.overflow;
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";
    }

    return () => {
      activeLockCount = Math.max(0, activeLockCount - 1);
      if (activeLockCount === 0) {
        body.style.overflow = previousBodyOverflow;
        html.style.overflow = previousHtmlOverflow;
        previousBodyOverflow = "";
        previousHtmlOverflow = "";
      }
    };
  }, [isOpen]);
};
